/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState } from 'react'


//*Services
import { loginWithFirebase, getUserData, signout, resetAuthPassword } from '../../services/Auth';
import { errorToast, successToast } from "../../services/Toast";
import { Link, useNavigate } from 'react-router-dom';

//*MUI
import Button from '../../SubComponent/Button';
import { makeStyles } from '@mui/styles';
import cssClasses from "./Login.module.css"
import { CustomTextInput } from '../../SubComponent/CustomTextInput';
import { Grid, Card, Paper, Box } from '@mui/material';
import loginImage from "../../assets/images/icons/loginImage.png";
import { dismissLoader, presentLoader } from '../../services/loaderService';
import { isEmailValid, LoginPasswordIsValid, } from '../../services/Validations';


const useStyles = makeStyles((theme) => ({
  ImageStyle: {
    marginRight: '10px',
    marginTop: '3px',
  },

  IconWrapper: {
    textDecoration: 'none',
    color: '#6941C6',
    marginLeft: "3px",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    fontWeight: 500,
  },
  CardGrid: {
    width: '44.4rem',
    height: '59.5rem',
    marginLeft: '1.8rem',
    borderTopLeftRadius: '25px',
    borderBottomLeftRadius: '25px',
  }

}));


export default function Login() {

  const KeyPressed = e => {
    if (e.key === 'Enter') {
      FirebaseLogin();
    }
  };

  const keyPressedForgot = e => {
    if (e.key === 'Enter') {
      forgotPassword()
    }
  }

  const classList = useStyles();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState("");
  const [buttonSignIn, setButtonSignIn] = useState(false);


  const [SignUpFields, setSignUpFields] = useState({
    email: '',
    password: '',
  });
  const [SignUpFieldHelperText, setSignUpFieldHelperText] = useState({
    email: '',
    password: '',
  });



  async function FirebaseLogin() {
    let isValid = isEmailValid(SignUpFields.email);
    let passwordValid = LoginPasswordIsValid(SignUpFields.password);
    setSignUpFieldHelperText((pre) => {
      pre.email = isValid.helperText;
      pre.password = passwordValid.helperText;
      return { ...pre };
    });

    presentLoader()

    if (isValid.flag && passwordValid.flag) {
      loginWithFirebase(email, password).then(res => {
        getUserData(res.user.uid).then(resp => {
          console.log('resp: ', resp);
          if (resp.success) {
            successToast("Login successfully.");
            presentLoader()
            setButtonSignIn(true);
            dismissLoader();
            navigate('/home');
          } else {
            dismissLoader();
            errorToast("User does not exist!");
          }
        }).catch(err => {
          errorToast("Something went wrong! Try again");
          signout().then(() => {
            navigate('/');
          });
        })
      }).catch((error) => {
        console.log(error.code);
        if (error.code === "auth/too-many-requests") {
          errorToast('Too Many attempts! please try in some time.')
        }
        if (error.code === "auth/wrong-password") {
          errorToast("Please check the password");
        }
        if (error.code === "auth/user-not-found") {
          errorToast("Please check the email");
        }
        if (error.code === "auth/email-already-in-use") {
          errorToast("Email already exists!");
        }

        if (error.code === "auth/configuration-not-found") {
          errorToast("User not found.");
        }
        dismissLoader();
      })
    } else {
      dismissLoader();
    }
  }


  const forgotPassword = () => {
    if (email === '') {
      errorToast('Please enter the email!')
    }
    presentLoader()
    resetAuthPassword(email)
      .then(function () {
        dismissLoader()
        successToast("Please check your email to reset your password")
      }).catch((error) => {
        console.log(error.code);
        if (error.code === "auth/user-not-found") {
          errorToast("Please check the email");
        }
      })
  }

  return (
    <Grid style={{ width: "100%", height: "100%" }} display={"flex"}>
      <Paper sx={{ margin: "auto" }} className={cssClasses.paperWrapper}>
        <Grid container
          spacing={0}
          direction="row"
          alignItems="center"
          justifyContent="center"
          columns={16}
        >
          <Grid item md={8} lg={7.5}>
            <Box className={cssClasses.subContainer}>
              <Box className={cssClasses.HeaderTitle} m={"2rem 0"}>Welcome back</Box>
              <Box className={cssClasses.SubTitle} mb={"2rem"}>Welcome back! Please enter your details.</Box>
              <Box height={"auto"} mb={"2rem"}>
                <CustomTextInput
                  name={'Enter your Email'}
                  inputType={'email'}
                  value={SignUpFields.email}
                  onChangeValue={(_value) => {
                    let pre = Object.assign({}, SignUpFields);
                    pre.email = _value;
                    setSignUpFields({ ...pre });
                    setSignUpFieldHelperText((pre) => {
                      pre.email = isEmailValid(_value).helperText;
                      setEmail(_value);
                      return { ...pre };
                    });
                  }}
                  helperText={SignUpFieldHelperText.email}
                />
              </Box>
              <Box height={"auto"} mb={"2rem"}>
                <CustomTextInput
                  name={'Password'}
                  inputType={'password'}
                  value={SignUpFields.password}
                  onChangeValue={(_value) => {
                    let pre = Object.assign({}, SignUpFields);
                    pre.password = _value;
                    setSignUpFields({ ...pre });
                    setSignUpFieldHelperText((pre) => {
                      pre.password = LoginPasswordIsValid(_value).helperText;
                      setPassword(_value);
                      return { ...pre };
                    })
                  }}
                  helperText={SignUpFieldHelperText.password}
                />
              </Box>


              <Box className={cssClasses.middleDiv}>
                <Box className={cssClasses.subDiv}>
                  <Box className={cssClasses.FpStyle} tabIndex="0" onKeyPress={keyPressedForgot} mb={"2rem"} onClick={() => forgotPassword()}>
                    Forgot password?
                  </Box>
                </Box>
              </Box>




              <Button
                style={{ color: "#ffffff", backgroundColor: "#3C4952" }}
                btnName={"Sign In"}
                padding={'1rem 4.75rem'}
                clicked={() => FirebaseLogin()}
                disable={buttonSignIn}
                handleKeypress={KeyPressed}
              />


              <Box className={cssClasses.lastDiv} m={"2rem 0"}>
                <Box className={cssClasses.SubTitle}>Don’t have an account?</Box>
                <Link className={classList.IconWrapper} to='/Signup'>
                  Sign up
                </Link>
              </Box>
            </Box>
          </Grid>


          <Grid item display={{ xs: "none", sm: "none", lg: "block", md: "block" }} sm={8} md={8} lg={8} >
            <Card className={classList.CardGrid}>
              <img src={loginImage} alt="colorImage" height="100%" width="100%" />
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}
